// @spec DHB-STR-013
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { MyEntriesPage } from '@/features/datahub/components/MyEntriesPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/my-entries')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.myDataEntries'),
  }),
  component: MyEntriesPage,
});
